"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));

var Paper_1 = __importDefault(require("@material-ui/core/Paper"));

var Popper_1 = __importDefault(require("@material-ui/core/Popper"));

var styles_1 = require("@material-ui/core/styles");

var classnames_1 = __importDefault(require("classnames"));

var downshift_1 = __importDefault(require("downshift"));

var React = __importStar(require("react"));

require("./BB8Lookup.scss");

var renderInput = function renderInput(inputProps) {
  var id = inputProps.id,
      InputProps = inputProps.InputProps,
      classes = inputProps.classes,
      clearSelection = inputProps.clearSelection,
      loading = inputProps.loading,
      ref = inputProps.ref,
      other = __rest(inputProps, ["id", "InputProps", "classes", "clearSelection", "loading", "ref"]);

  return React.createElement(React.Fragment, null, React.createElement("input", __assign({
    type: "text",
    className: classnames_1.default('bb8-search', classes.inputInput, classes.inputRoot),
    ref: ref
  }, InputProps, other)), React.createElement(core_1.IconButton, {
    disabled: InputProps.disabled,
    className: classnames_1.default('bb8-search-icon', {
      show: !!InputProps.value && !loading && !InputProps.disabled
    }),
    onClick: clearSelection
  }, React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }), React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }))), React.createElement(core_1.CircularProgress, {
    className: classnames_1.default('bb8-search-icon', {
      show: loading
    })
  }));
};

var defaultRenderOption = function defaultRenderOption(_a) {
  var id = _a.id,
      classes = _a.classes,
      highlightedIndex = _a.highlightedIndex,
      index = _a.index,
      itemProps = _a.itemProps,
      selectedItem = _a.selectedItem,
      option = _a.option;
  var isHighlighted = highlightedIndex === index; // const isSelected = (selectedItem || "").indexOf(option) > -1;

  return React.createElement(MenuItem_1.default, __assign({}, itemProps, {
    key: option,
    selected: isHighlighted,
    component: "div",
    className: classes.menuItem
  }), option);
};

var styles = styles_1.createStyles(function (theme) {
  return {
    chip: {
      margin: theme.spacing.unit / 2 + "px " + theme.spacing.unit / 4 + "px"
    },
    container: {
      alignItems: 'center',
      display: 'flex',
      position: 'relative'
    },
    inputInput: {
      width: 'auto'
    },
    inputRoot: {
      flexWrap: 'wrap'
    },
    menuItem: {
      fontFamily: theme.typography.fontFamily
    },
    popper: {
      zIndex: 9999
    },
    root: {
      fontFamily: theme.typography.fontFamily
    }
  };
});

var BB8LookupInner =
/** @class */
function (_super) {
  __extends(BB8LookupInner, _super);

  function BB8LookupInner() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      inputValue: ''
    };

    _this.handleInputBlur = function (e) {
      if (_this.props.onInputBlur) {
        _this.props.onInputBlur(e);
      }
    };

    _this.handleInputChange = function (e) {
      if (_this.props.onInputChange) {
        _this.props.onInputChange(e);
      }
    };

    _this.handleInputFocus = function (e, openMenu) {
      if (_this.props.shouldOpenOnFocus) {
        openMenu();
      }
    };

    _this.handleStateChange = function (changes) {
      if (changes.hasOwnProperty('inputValue')) {
        _this.setState({
          inputValue: changes.inputValue
        });
      }
    };

    return _this;
  }

  BB8LookupInner.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        classes = _a.classes,
        defaultValue = _a.defaultValue,
        disabled = _a.disabled,
        itemToString = _a.itemToString,
        loading = _a.loading,
        placeholder = _a.placeholder,
        onSelect = _a.onSelect,
        options = _a.options,
        renderOption = _a.renderOption,
        name = _a.name;
    return React.createElement("div", {
      className: classnames_1.default('bb8-search-wrapper', classes.root)
    }, React.createElement(downshift_1.default, {
      id: id,
      onChange: onSelect,
      itemToString: itemToString,
      onStateChange: this.handleStateChange,
      initialSelectedItem: this.props.value || undefined
    }, function (_a) {
      var clearSelection = _a.clearSelection,
          getInputProps = _a.getInputProps,
          getItemProps = _a.getItemProps,
          getMenuProps = _a.getMenuProps,
          highlightedIndex = _a.highlightedIndex,
          isOpen = _a.isOpen,
          selectedItem = _a.selectedItem,
          openMenu = _a.openMenu;
      return React.createElement("div", {
        className: classes.container
      }, renderInput({
        InputProps: getInputProps({
          defaultValue: defaultValue,
          disabled: disabled,
          name: name,
          onBlur: _this.handleInputBlur,
          onChange: _this.handleInputChange,
          onFocus: function onFocus(e) {
            return _this.handleInputFocus(e, openMenu);
          },
          placeholder: placeholder
        }),
        classes: classes,
        clearSelection: clearSelection,
        loading: loading,
        ref: function ref(node) {
          _this.popperNode = node;
        }
      }), React.createElement(Popper_1.default, {
        open: isOpen,
        anchorEl: _this.popperNode,
        className: classes.popper
      }, React.createElement("div", __assign({}, isOpen ? getMenuProps({}, {
        suppressRefError: true
      }) : {}), React.createElement(Paper_1.default, {
        square: true,
        style: {
          marginTop: 8,
          maxHeight: '300px',
          overflowY: 'auto',
          width: _this.popperNode ? _this.popperNode.clientWidth : null
        }
      }, options && options.length ? options.map(function (option, index) {
        return (renderOption || defaultRenderOption)({
          classes: classes,
          highlightedIndex: highlightedIndex,
          id: id,
          index: index,
          itemProps: getItemProps({
            item: option
          }),
          option: option,
          selectedItem: selectedItem
        });
      }) : null))));
    }));
  };

  return BB8LookupInner;
}(React.Component);

exports.default = styles_1.withStyles(styles)(BB8LookupInner);